/**
 * Created by slava on 04.10.2023
 */

const BackgroundScroller = cc.Node.extend({
    ctor: function (moveNext) {
        this._super();
        this.moveNext = moveNext || false;

        this.onResize();
    },

    changeItemScale: function (scroll) {
        const styles = cleverapps.styles.BackgroundScroller;

        const maxScale = this.itemBaseScale || styles.scroll.baseScale[cleverapps.resolution.mode];
        const minScale = maxScale * styles.scroll.scale[cleverapps.resolution.mode];

        const pos = scroll.getContainerPosition();

        let offset;
        if (scroll.direction === cleverapps.UI.ScrollView.DIR_HORIZONTAL) {
            offset = (pos.x + (scroll.innerContent.width - scroll.pageSize.width) / 2) / scroll.pageSize.width;
        } else {
            offset = scroll.getPagesAmount() - 1 - (pos.y + (scroll.innerContent.height - scroll.pageSize.height) / 2) / scroll.pageSize.height;
        }

        const updateItem = (index, scaleValue) => {
            const item = scroll.items[index];

            if (item && item.loadBackground) {
                item.loadBackground();
            }

            if (item && item.spine) {
                item.spine.setScale(scaleValue);
            }
        };

        const interpolateLinear = (start, end, progress) => start + (end - start) * progress;

        const currentPageIndex = cleverapps.clamp(Math.floor(offset), 0, scroll.getPagesAmount() - 1);

        const progress = offset - currentPageIndex;

        updateItem(currentPageIndex, interpolateLinear(maxScale, minScale, progress));
        updateItem(currentPageIndex + 1, interpolateLinear(maxScale, minScale, 1 - progress));
        updateItem(currentPageIndex - 1, minScale);
    },

    onResize: function () {
        var style = cleverapps.styles.BackgroundScroller;
        const mode = cleverapps.resolution.mode;
        const sceneWidth = cleverapps.resolution.getSceneSize().width;
        if (this.resolutionMode !== mode || mode === cleverapps.WideMode.VERTICAL && this.sceneWidth !== sceneWidth) {
            this.resolutionMode = mode;
            this.sceneWidth = sceneWidth;
            this.itemBaseScale = undefined;
            this.createScroll();
        }
        this.setContentSize2(this.scroll.width, this.scroll.height);
        this.setAlignment(style.position);
        this.scroll.setAlignment(style.position);

        const current = cleverapps.meta.getSelectedLocation().getStage();
        this.scroll.onUpdatePositionListener = this.changeItemScale.bind(this, this.scroll);
        this.scroll.scrollTo(this.items[this.moveNext ? current - 1 : current], 0);
    },

    createScroll: function () {
        if (this.scroll) {
            this.scroll.removeFromParent();
        }

        const styles = cleverapps.styles.BackgroundScroller;
        const items = this.createItems();

        let direction = cleverapps.UI.HORIZONTAL;
        let width = this.items[0].width * BackgroundScroller.PAGES_COUNT;
        let height = this.items[0].height * (styles.scroll.baseScale[cleverapps.resolution.mode] / styles.scroll.scale[cleverapps.resolution.mode]);
        if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            direction = cleverapps.UI.VERTICAL;
            width = this.items[0].width + styles.padding;
            height = this.items[0].height * BackgroundScroller.PAGES_COUNT;
        }

        const scroll = this.scroll = new SnapScrollView(items, {
            direction,
            pagesCount: BackgroundScroller.PAGES_COUNT,
            height,
            width,
            scrollBarEnabled: false
        });
        this.addChild(scroll);

        if (!this.itemBaseScale && cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            this.itemBaseScale = Math.min(1, (this.sceneWidth - styles.padding) / this.items[0].spine.width);
            this.createScroll();
        }
    },

    createItems: function () {
        const styles = cleverapps.styles.BackgroundScroller;
        const baseScale = this.itemBaseScale || styles.scroll.baseScale[cleverapps.resolution.mode];
        const scale = baseScale * styles.scroll.scale[cleverapps.resolution.mode];

        this.items = [];

        for (let index = 0; bundles.backgrounds_window.urls[`background_${index}`]; index++) {
            const item = new BackgroundsItem({
                locationId: index,
                padding: 25,
                baseScale,
                scale,
                moveNext: this.moveNext
            });
            this.items.push(item);
        }

        const current = cleverapps.meta.getSelectedLocation().getStage();

        if (current >= this.items.length - 1) {
            const comingSoonItem = new BackgroundsItem({
                locationId: "coming_soon",
                padding: 25,
                baseScale,
                scale,
                comingSoon: true,
                moveNext: this.moveNext
            });
            this.items.push(comingSoonItem);
        }

        return [this.createEmptyItem(this.items[0].getContentSize())].concat(this.items);
    },

    createEmptyItem: function (size) {
        const container = new cc.Node();
        container.setAnchorPoint(0, 0);
        container.setContentSize2(size);
        return container;
    }
});

cleverapps.styles.BackgroundScroller = {
    padding: 40,

    position: {
        x: { align: "center" },
        y: { align: "center" }
    },

    scroll: {
        position: [{
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 20 }
        }, {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 0 }
        }, {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 0 }
        }],
        baseScale: [0.55, 1, 1],
        scale: [0.85, 0.6, 0.6],
        diffX: 20,
        dx: 8
    },

    item: {
        button: {
            position: {
                x: { align: "center", dx: 0 },
                y: { align: "center", dy: 0 }
            }
        },
        location_number: {
            position: {
                x: { align: "center", dx: 0 },
                y: { align: "center", dy: 0 }
            }
        },
        demo: {
            position: {
                x: { align: "center", dx: 0 },
                y: { align: "center", dy: 0 }
            }
        },
        frame: {
            position: {
                x: { align: "center", dx: 0 },
                y: { align: "center", dy: 0 }
            }
        },
        title_base: {
            position: {
                x: { align: "center", dx: 0 },
                y: { align: "center", dy: 0 }
            }
        },
        title: {
            position: {
                x: { align: "center", dx: 0 },
                y: { align: "center", dy: 0 }
            }
        },
        lock: {
            position: {
                x: { align: "center", dx: 0 },
                y: { align: "center", dy: 0 }
            }
        },
        proggressbar: {
            position: {
                x: { align: "center", dx: 0 },
                y: { align: "center", dy: 0 }
            }
        }
    }
};

BackgroundScroller.PAGES_COUNT = 3;